import { render, staticRenderFns } from "./TableMain.vue?vue&type=template&id=751c306e&scoped=true"
import script from "./TableMain.vue?vue&type=script&lang=js"
export * from "./TableMain.vue?vue&type=script&lang=js"
import style0 from "./TableMain.vue?vue&type=style&index=0&id=751c306e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751c306e",
  null
  
)

export default component.exports